import { useRouter } from 'expo-router';
import { Linking } from 'react-native';

import { isExternalLink } from 'utils/is-external-link';

export const useContentCardNavigation = () => {
  const router = useRouter();

  const navigate = ({ url }: { url: string }) => {
    if (!url) {
      return;
    }

    if (isExternalLink(url)) {
      // Open absolute URLs in the default browser
      Linking.openURL(url);
    } else {
      // Navigate within the app for relative URLs
      router.replace(url);
    }
  };

  return {
    navigate,
  };
};
